// extracted by mini-css-extract-plugin
export var close = "style-mod--close--1e8a3";
export var container = "style-mod--container--68a44";
export var scalapay = "style-mod--scalapay--179bd";
export var scalapayContainer = "style-mod--scalapay-container--6a1a2";
export var scalapayDescription = "style-mod--scalapay-description--c1194";
export var scalapayIcon = "style-mod--scalapay-icon--aeaf9";
export var scalapayIcons = "style-mod--scalapay-icons--60e76";
export var scalapayModal = "style-mod--scalapay-modal--5df7c";
export var scalapaySubtitle = "style-mod--scalapay-subtitle--90743";
export var scalapayTitle = "style-mod--scalapay-title--e3cfc";
export var visitScalapay = "style-mod--visit-scalapay--5d121";